export default __webpack_public_path__ + "static/media/notificationwhite.d75e5bf6.svg";